import BaseService from './BaseService';

class MenuService extends BaseService {
    getMenu = () => this.get('/menus');

    getMenuCategories = () => this.get('/menu-categories');
}

export default new MenuService();
